/**
 * Targeting Rule Validation
 * 
 * Client-side validation helpers that call backend validation API
 */

import type { TargetingRuleV1, ValidationResult } from "./types";
import { validateTargetingRule as apiValidateTargetingRule } from "../../api/campaigns";

/**
 * Validate targeting rule via backend API
 */
export async function validateTargetingRule(
  rule: TargetingRuleV1
): Promise<ValidationResult> {
  try {
    const result = await apiValidateTargetingRule(rule);
    return result;
  } catch (error) {
    console.error("Validation error:", error);
    return {
      valid: false,
      errors: [
        {
          path: "rule",
          message: error instanceof Error ? error.message : "Validation failed",
          code: "VALIDATION_ERROR",
        },
      ],
    };
  }
}
